export const environment = {
  production: false,
  apiUrl: 'https://webapp-api-crm-next-dev-wus.azurewebsites.net'
};
